<template>
  <div class="LayoutNavBtn">
    <div :class="`LayoutNavBtn-container ${active}`">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutNavBtn",
  props: {
    visible: Boolean,
  },
  computed: {
    active: function() {
      const { visible } = this;
      return visible ? "active" : "";
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './LayoutNavBtn.styl';
</style>
